import {
  ACTION_SET_SITE_FOOTER_LINK_TRANSLATION_AVAILABILITY__SUCCESS,
  ACTION_SET_SITE_FOOTER_LINK_TRANSLATION_AVAILABILITY__FAIL,
  ACTION_SET_SITE_FOOTER_LINK_TRANSLATION_AVAILABILITY__REQUEST,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_SET_SITE_FOOTER_LINK_TRANSLATION_AVAILABILITY__SUCCESS:
    case ACTION_SET_SITE_FOOTER_LINK_TRANSLATION_AVAILABILITY__REQUEST:
      return null;

    case ACTION_SET_SITE_FOOTER_LINK_TRANSLATION_AVAILABILITY__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
